"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop2 = _interopRequireDefault(require("lodash-es/noop"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _commonHelper = require("../helpers/commonHelper");
var _buttonHelper = require("./buttonHelper");
var _misc = _interopRequireDefault(require("../tokens/misc"));
var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));
var _SpinnerCircular = _interopRequireDefault(require("../Spinner/SpinnerCircular"));
var _typography = require("../tokens/typography");
var _excluded = ["onClick", "disabled", "loading"],
  _excluded2 = ["component"],
  _excluded3 = ["children"];
/* eslint-disable react/prop-types */
// libraries
// helpers
var GetButtonContent = function GetButtonContent(props) {
  var content = [];
  var onClick = props.onClick,
    disabled = props.disabled,
    loading = props.loading,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var handleClick = function handleClick(event) {
    event.stopPropagation();
    onClick(event);
  };

  // Button text
  // eslint-disable-next-line react/prop-types
  if (props.text) content.push( /*#__PURE__*/_react["default"].createElement(Button.Text, {
    key: "text"
  }, props.text));
  var normalSpinner = [/*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
    inverse: props.appearance !== _misc["default"].button.appearances.outline,
    color: (0, _buttonHelper.getBtnAttributes)(props).hoverText || (0, _buttonHelper.getBtnAttributes)(props).text,
    key: "loading",
    width: (0, _buttonHelper.getBtnAttributes)(props).iconSize
  })];
  var circularSpinner = [/*#__PURE__*/_react["default"].createElement(_SpinnerCircular["default"], {
    inverse: props.appearance !== _misc["default"].button.appearances.outline,
    color: (0, _buttonHelper.getBtnAttributes)(props).hoverText || (0, _buttonHelper.getBtnAttributes)(props).text,
    key: "loading",
    size: "small"
  })];
  if (!props.disabled && loading) {
    content = !(props.icon && !props.children) ? normalSpinner : circularSpinner;
  }
  if (props.icon && !loading) {
    var Icon = /*#__PURE__*/(0, _styledComponents["default"])(function (_ref) {
      var component = _ref.component,
        props = (0, _objectWithoutProperties2["default"])(_ref, _excluded2);
      return (0, _commonHelper.cloneChildren)(component, props);
    }).withConfig({
      componentId: "sc-1kx5g6g-0"
    })(["transition:transform 0.4s;", ":hover &{fill:", ";}"], Button.Element, function (props) {
      return props.hoverColor;
    });
    var iconEle = /*#__PURE__*/_react["default"].createElement(Icon, {
      component: props.icon,
      color: (0, _buttonHelper.getBtnAttributes)(props).text,
      size: (0, _buttonHelper.getBtnAttributes)(props).iconSize,
      hoverColor: (0, _buttonHelper.getBtnAttributes)(props).hoverText,
      key: "icon"
    });
    props.iconAlign == "right" ? content.push(iconEle) : content.unshift(iconEle);
  }

  /** className is passed dynamically by styled components
   * so if we do {...props}, it will apply parent styles to the child as well.
   * it will break the styles of components
   * */
  /**
   * 'loading' property should not be passed down to native html element
   * unless it's an image element.
   */
  var childProps = (0, _commonHelper.filterChildProps)(props, ["className", "loading"]);
  return /*#__PURE__*/_react["default"].createElement(Button.Element, (0, _extends2["default"])({}, rest, {
    disabled: disabled,
    role: "button",
    tabIndex: "0",
    "aria-disabled": disabled,
    key: "button-element",
    isLoading: loading
  }), /*#__PURE__*/_react["default"].createElement(Button.ContentWrapper, (0, _extends2["default"])({}, childProps, {
    tabIndex: -1,
    onClick: handleClick,
    onKeyDown: (0, _commonHelper.onKeySelect)(handleClick)
  }), content));
};
var Button = function Button(_ref2) {
  var children = _ref2.children,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(GetButtonContent, (0, _extends2["default"])({}, props, {
    text: children
  }));
};
Button.Element = _styledComponents["default"].button.withConfig({
  componentId: "sc-1kx5g6g-1"
})(["min-width:", ";min-height:", ";display:inline-flex;align-items:stretch;border-radius:", ";background:transparent;padding:0;border:none;&:focus,&:active{outline:none;box-shadow:none;}cursor:", ";pointer-events:", ";"], (0, _buttonHelper.getAttr)("minWidth"), (0, _buttonHelper.getAttr)("lineHeight"), _misc["default"].radius, function (props) {
  return props.disabled ? "not-allowed" : "pointer";
}, function (props) {
  return props.disabled || props.isLoading || props.success ? "none" : null;
});
Button.ContentWrapper = _styledComponents["default"].span.withConfig({
  componentId: "sc-1kx5g6g-2"
})(["display:inline-flex;vertical-align:middle;align-items:center;justify-content:center;height:100%;width:100%;min-width:", ";min-height:", ";line-height:", ";margin-top:0;margin-left:0;outline:none !important;white-space:nowrap;font-size:", ";font-weight:", ";background:", ";border-color:", ";border-width:", ";border-style:solid;border-radius:", ";color:", ";padding:0 ", ";opacity:", ";background-clip:border-box;transition:transform ", ",opacity ", ",box-shadow ", " ease;> *:not(:last-child):not(:only-child){margin-right:", ";line-height:1;}", ":focus &{color:", ";background:", ";border-color:", ";box-shadow:0 0 0 4px #fff,0 0 0 5px #717171,0 0 0 6px rgba(255,255,255,0.5);}&:not(:-moz-focusring):focus{box-shadow:none;}", ":active &{background:", ";border-color:", ";outline:none;box-shadow:", ";}@media (hover:hover){", " ", ":hover,", ":focus{color:", ";background:", ";border-color:", ";}&:hover{i{transform:", ";}color:", ";background:", ";border-color:", ";}}@media (hover:none){", " ", ":focus &{outline:none;box-shadow:none !important;}}", ""], (0, _buttonHelper.getAttr)("minWidth"), (0, _buttonHelper.getAttr)("lineHeight"), (0, _buttonHelper.getAttr)("lineHeight"), (0, _buttonHelper.getAttr)("fontSize"), _typography.fontWeights.light, (0, _buttonHelper.getAttr)("background"), (0, _buttonHelper.getAttr)("border"), (0, _buttonHelper.getAttr)("borderWidth"), _misc["default"].radius, (0, _buttonHelper.getAttr)("text"), (0, _buttonHelper.getAttr)("padding"), function (props) {
  return props.disabled ? 0.5 : 1;
}, _misc["default"].animationDuration, _misc["default"].animationDuration, _misc["default"].animationDuration, _buttonHelper.getBtnSpacing, Button.Element, (0, _buttonHelper.getAttr)("hoverText") || (0, _buttonHelper.getAttr)("text"), (0, _buttonHelper.getAttr)("hoverBackground"), (0, _buttonHelper.getAttr)("hoverBorder"), Button.Element, (0, _buttonHelper.getAttr)("activeBackground"), (0, _buttonHelper.getAttr)("activeBorder"), function (props) {
  return (0, _buttonHelper.getBtnAttributes)(props).customBoxShadow;
}, "" /* css for non touch devices, (hover enabled screens to be precised) goes here  */, Button.Element, Button.Element, (0, _buttonHelper.getAttr)("hoverText") || (0, _buttonHelper.getAttr)("text"), (0, _buttonHelper.getAttr)("hoverBackground"), (0, _buttonHelper.getAttr)("hoverBorder"), function (_ref3) {
  var iconAlign = _ref3.iconAlign;
  return "translate(".concat(iconAlign === "left" ? -4 : 8, "px, 0)");
}, (0, _buttonHelper.getAttr)("hoverText") || (0, _buttonHelper.getAttr)("text"), (0, _buttonHelper.getAttr)("hoverBackground"), (0, _buttonHelper.getAttr)("hoverBorder"), "" /* css for touch devices, (non-hover screens to be precised) goes here  */, Button.Element, _buttonHelper.getButtonRippleStyles);
Button.Text = _styledComponents["default"].span.withConfig({
  componentId: "sc-1kx5g6g-3"
})(["display:inline-block;vertical-align:middle;line-height:normal;font-size:inherit;transition:transform 0.4s;*:last-child:not(:only-child){margin-top:0.1rem;}"]);
Button.LinkElement = (0, _styledComponents["default"])(Button.Element.withComponent("a")).withConfig({
  componentId: "sc-1kx5g6g-4"
})(["text-decoration:none;"]);
Button.propTypes = {
  /** Add a callback on click of button component */
  onClick: _propTypes["default"].func,
  title: _propTypes["default"].string,
  /** Condidtionally disable / Enable a Button */
  disabled: _propTypes["default"].bool,
  /** color of button, should be one of primary colors */
  btnColor: _propTypes["default"].oneOf(["red", "green", "blue", "yellow", "purple", "lime", "coal", "chalk", "avocado", "teal"]),
  /** Whether button should appears to be solid or White button with given color boundary and Text */
  appearance: _propTypes["default"].oneOf(["outline", "solid", "link", "location"]),
  /** Switch Loading state on/off */
  loading: _propTypes["default"].bool,
  /** Size of button */
  size: _propTypes["default"].oneOf(["large", "default", "compressed", "small", "largeIcon"]),
  /** Icon which goes on button along with Text */
  icon: _propTypes["default"].node,
  /** Position of icon, before or after text */
  iconAlign: _propTypes["default"].oneOf(["left", "right"]),
  preventRipple: _propTypes["default"].bool
};
Button.defaultProps = {
  onClick: _noop2["default"],
  disabled: false,
  loading: false,
  appearance: "solid",
  size: "default",
  iconAlign: "left",
  btnColor: "red",
  preventRipple: false
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(Button);